// Boots
import b1 from './images/products/boots/p1.png';
import b2 from './images/products/boots/p2.jpg';
import b3 from './images/products/boots/p3.jpg';
import b4 from './images/products/boots/p4.png';
import b5 from './images/products/boots/p5.png';
import b6 from './images/products/boots/p6.jpg';
import b7 from './images/products/boots/p7.jpg';
import b8 from './images/products/boots/p8.jpg';
import b9 from './images/products/boots/p9.jpg';
import b10 from './images/products/boots/p10.png';
import b11 from './images/products/boots/p11.jpg';
import b12 from './images/products/boots/p12.png';
import b13 from './images/products/boots/p13.png';
import b14 from './images/products/boots/p14.png';
import b15 from './images/products/boots/p15.jpg';
import b16 from './images/products/boots/p16.jpg';
import b17 from './images/products/boots/p17.jpg';
import b18 from './images/products/boots/p18.jpg';


// coverall
// ploy-cotton
import pc1 from './images/products/coveralls/poly-cotton/p1.png';
import pc2 from './images/products/coveralls/poly-cotton/p2.png';
import pc3 from './images/products/coveralls/poly-cotton/p3.png';

// coverall
// FR
import fr1 from './images/products/coveralls/FR/p1.png';
import fr2 from './images/products/coveralls/FR/p2.png';
import fr3 from './images/products/coveralls/FR/p3.jpg';
import fr4 from './images/products/coveralls/FR/p4.png';
import fr5 from './images/products/coveralls/FR/p5.jpg';
import fr6 from './images/products/coveralls/FR/p6.png';
import fr7 from './images/products/coveralls/FR/p7.png';
import fr8 from './images/products/coveralls/FR/p8.png';
import fr9 from './images/products/coveralls/FR/p9.jpg';
import fr10 from './images/products/coveralls/FR/p10.jpg';
import fr11 from './images/products/coveralls/FR/p11.png';
import fr12 from './images/products/coveralls/FR/p12.png';
import fr13 from './images/products/coveralls/FR/p13.png';
import fr14 from './images/products/coveralls/FR/p14.png';
import fr15 from './images/products/coveralls/FR/p15.png';
import fr16 from './images/products/coveralls/FR/p16.png';

// coverall
// medical
import mc1 from './images/products/coveralls/medical/p1.jpg';
import mc2 from './images/products/coveralls/medical/p2.jpg';
import mc3 from './images/products/coveralls/medical/p3.png';
import mc4 from './images/products/coveralls/medical/p4.jpg';
import mc5 from './images/products/coveralls/medical/p5.jpg';


// eye wear
import e1 from './images/products/glasses/p1.jpg';
import e2 from './images/products/glasses/p2.png';
import e3 from './images/products/glasses/p3.png';
import e4 from './images/products/glasses/p4.jpg';
import e5 from './images/products/glasses/p5.jpg';
import e6 from './images/products/glasses/p6.jpg';
import e7 from './images/products/glasses/p7.jpg';
import e8 from './images/products/glasses/p8.jpg';
import e9 from './images/products/glasses/p9.png';


// hats
import h1 from './images/products/hats/p1.png';
import h2 from './images/products/hats/p2.jpg';
import h3 from './images/products/hats/p3.jpg';
import h4 from './images/products/hats/p4.jpg';
import h5 from './images/products/hats/p5.jpg';
import h6 from './images/products/hats/p6.jpg';
import h7 from './images/products/hats/p7.jpg';
import h8 from './images/products/hats/p8.png';
import h9 from './images/products/hats/p9.png';
import h10 from './images/products/hats/p10.jpg';
import h11 from './images/products/hats/p11.jpg';

// gloves
import g1 from './images/products/gloves/p1.png';
import g2 from './images/products/gloves/p2.png';
import g3 from './images/products/gloves/p3.png';
import g4 from './images/products/gloves/p4.png';
import g5 from './images/products/gloves/p5.png';
import g6 from './images/products/gloves/p6.png';
import g7 from './images/products/gloves/p7.png';
import g8 from './images/products/gloves/p8.png';
import g9 from './images/products/gloves/p9.png';
import g10 from './images/products/gloves/p10.png';
import g11 from './images/products/gloves/p11.png';
import g12 from './images/products/gloves/p12.png';
import g13 from './images/products/gloves/p13.png';
import g14 from './images/products/gloves/p14.png';
import g15 from './images/products/gloves/p15.png';
import g16 from './images/products/gloves/p16.jpg';
import g17 from './images/products/gloves/p17.png';
import g18 from './images/products/gloves/p18.jpg';
import g19 from './images/products/gloves/p19.jpg';
import g20 from './images/products/gloves/p20.png';
import g21 from './images/products/gloves/p21.jpg';
import g22 from './images/products/gloves/p22.jpg';
import g23 from './images/products/gloves/p23.jpg';
import g24 from './images/products/gloves/p24.jpg';
import g25 from './images/products/gloves/p25.jpg';
import g26 from './images/products/gloves/p26.jpg';
import g27 from './images/products/gloves/p27.jpg';
import g28 from './images/products/gloves/p28.jpg';
import g29 from './images/products/gloves/p29.jpg';
import g30 from './images/products/gloves/p30.png';


// masks
import m1 from './images/products/masks/p1.png';
import m2 from './images/products/masks/p2.jpg';
import m3 from './images/products/masks/p3.jpg';
import m4 from './images/products/masks/p4.png';
import m5 from './images/products/masks/p5.png';
import m6 from './images/products/masks/p6.jpg';
import m7 from './images/products/masks/p7.jpg';
import m8 from './images/products/masks/p8.jpg';
import m9 from './images/products/masks/p9.png';
import m10 from './images/products/masks/p10.png';
import m11 from './images/products/masks/p11.png';
import m12 from './images/products/masks/p12.png';
import m13 from './images/products/masks/p13.jpg';
import m14 from './images/products/masks/p14.png';
import m15 from './images/products/masks/p15.png';
import m16 from './images/products/masks/p16.png';
import m17 from './images/products/masks/p17.png';
import m18 from './images/products/masks/p18.jpg';
import m19 from './images/products/masks/p19.jpg';
import m20 from './images/products/masks/p20.jpg';
import m21 from './images/products/masks/p21.jpg';
import m22 from './images/products/masks/p22.png';
import m23 from './images/products/masks/p23.png';
import m24 from './images/products/masks/p24.jpg';
import m25 from './images/products/masks/p25.jpg';
import m26 from './images/products/masks/p26.png';
import m27 from './images/products/masks/p27.jpg';
import m28 from './images/products/masks/p28.jpg';
import m29 from './images/products/masks/p29.jpg';
import m30 from './images/products/masks/p30.jpg';
import m31 from './images/products/masks/p31.jpg';
import m32 from './images/products/masks/p32.jpg';
import m33 from './images/products/masks/p33.jpg';
import m34 from './images/products/masks/p34.jpg';
import m35 from './images/products/masks/p35.jpg';
import m36 from './images/products/masks/p36.jpg';
import m37 from './images/products/masks/p37.jpg';
import m38 from './images/products/masks/p38.jpg';
import m39 from './images/products/masks/p39.jpg';
import m40 from './images/products/masks/p40.jpg';
import m41 from './images/products/masks/p41.jpg';
import m42 from './images/products/masks/p42.jpg';
import m43 from './images/products/masks/p43.jpg';
import m44 from './images/products/masks/p44.jpg';
import m45 from './images/products/masks/p45.jpg';
import m46 from './images/products/masks/p46.jpg';
import m47 from './images/products/masks/p47.jpg';
import m48 from './images/products/masks/p48.jpg';

// roadsafety
import r1 from './images/products/road/p1.png';
import r2 from './images/products/road/p2.png';
import r3 from './images/products/road/p3.png';

let bp = [b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18];
let cp = [pc1, pc2, pc3, fr1, fr2, fr3, fr4, fr5, fr6, fr7, fr8, fr9, fr10, fr11, fr12, fr13, fr14, fr15, fr16, 
    mc1, mc2, mc3, mc4, mc5];
let ep = [e1, e2, e3, e4, e5, e6, e7, e8, e9];
let hp = [h1, h2, h3, h4, h5, h6, h7, h8, h9, h10, h11];
let gp = [g1, g2, g3, g4, g5, g6, g7, g8, g9, g10, g11, g12, g13, g14, g15, g16, g17, g18, g19, g20, g21, g22, g23, g24, 
    g25, g26, g27, g28, g29, g30,];
let mp = [m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15, m16, m17, m18, m19, m20, m21, m22, m23, m24, 
    m25, m26, m27, m28, m29, m30, m31, m32, m33, m34, m35, m36, m37, m38, m39, m40, m41, m42, m43, m44, m45, m46, m47, m48];
let rp = [r1, r2, r3];

export default {bp, cp, ep, hp, gp, mp, rp};